const namespace = "unregistrationError";

export const ERROR_MESSAGE = `${namespace}.errorMessage`;
export const OK = `${namespace}.ok`;
export const CLOSE = `${namespace}.close`;
